module.exports = __webpack_public_path__ + "img/collection-engagementRingsSignature@2x.501aa1d.webp";